import React from "react";
import { UseFormRegister } from "react-hook-form";
import { ReconciliationFormData } from "../ReconciliationModal";

export interface CampaignPOInputProps {
  po: string;
}
export const CampaignPOInput = React.forwardRef<
  HTMLInputElement,
  CampaignPOInputProps &
    Partial<ReturnType<UseFormRegister<ReconciliationFormData>>>
>(function BaseCampaignPOInput({ onChange, name, po }, ref) {
  return (
    <>
      <h5>Add a PO / invoice ID</h5>
      <input
        type="text"
        placeholder="PO / invoice ID"
        onChange={onChange}
        defaultValue={po}
        name={name}
        ref={ref}
        data-testid="po-input-testid"
      />
    </>
  );
});
